<h3-video-content-initializer
  [project]="taskWorkspaceStore.state().project"
  [output]="outputInfoStore.state().output"
  [readOnly]="taskWorkspaceStore('readOnly').$ | async"
  [isClientFeedbacksEditable]="isClientFeedbacksEditable"
  [isShapeFeedbackEditable]="isShapeFeedbackEditable"
  [currentUser]="taskWorkspaceStore.state().currentUser"
  [stepId]="taskWorkspaceStore.state().stepId"
  [frameNumber]="store.state().frameNumber"
  (initializationComplete)="onContentInitialized($event)"
></h3-video-content-initializer>
@if (contentInjector && (primaryMinionRegistered | async)) {
  <h3-video-layout [state]="store.$ | async"></h3-video-layout>
}

<ng-container *ngIf="showAddRandomShapes$ | async">
  <hr />
  <h3-add-random-shapes></h3-add-random-shapes>
</ng-container>
